import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useT, useLocalePath } from "@/i18n";
import { useSeo } from "@/lib/seo";

const NotFound = () => {
  const location = useLocation();
  const lp = useLocalePath();
  const t = useT(
    { title: "Seite nicht gefunden", text: "Diese Seite existiert leider nicht.", home: "Zurück zur Startseite" },
    { title: "Page not found", text: "Sorry, this page does not exist.", home: "Back to the homepage" },
  );

  useSeo({
    title: `${t.title} | PRAXIS IB`,
    description: t.text,
    canonical: location.pathname,
    hasEnglish: false,
    noindex: true,
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);


  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center px-4">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-2 text-xl text-foreground">{t.title}</p>
        <p className="mb-4 text-muted-foreground">{t.text}</p>
        <Link to={lp("/")} className="text-primary underline hover:text-primary/90">
          {t.home}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
